/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _FeelingEvasFormComponent;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import SurveyRequestedJournalEvent from "core/models/survey-requested-journal-event";
import JournalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import FeelingEvasDeclaredJournalEvent from "core/models/feeling-evas-declared-journal-event";
let FeelingEvasFormComponent = (_class = (_FeelingEvasFormComponent = class FeelingEvasFormComponent extends JournalEventBasedComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "journalEventProperties", ["occurredAt", "mood", "energy", "irritability", "sleepDuration", "anxiety", "comments"]);
    _defineProperty(this, "sliderStyles", "mt-[1.5em]");
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
  }
  labels(labels, value) {
    if (!labels[value]) return "";

    // HACK: using "&nbsp;" here to fix a positionning bug
    return "&nbsp;" + labels[value];
  }
  get defaultModel() {
    return {
      mood: 0,
      energy: 0,
      irritability: 0,
      sleepDuration: 0,
      anxiety: 0
    };
  }
  async save() {
    this.changeset.set("occurredAt", new Date());
    const journalEvent = await super.save();
    if (this.args.surveyRequested) {
      const surveyCompleted = this.store.createRecord("survey-completed-journal-event", {
        patient: this.patient,
        occurredAt: new Date(),
        rawInputs: this.model,
        linkedJournalEventIds: [journalEvent.id],
        formId: "feeling-evas/form",
        surveyRequestedJournalEvent: this.args.surveyRequested
      });
      await surveyCompleted.save();
    }
  }
  setProperty(propertyName, value) {
    const precision = 10;
    const roundedValue = Math.round(value * precision) / precision;
    if (roundedValue != value) {
      console.warn("FUI slider.js rounding bug happened. We had to re-round the value. See https://github.com/fomantic/Fomantic-UI/issues/1545");
    }
    if (this.changeset.get(propertyName) === roundedValue) return;
    this.changeset.set(propertyName, roundedValue);
  }
}, _defineProperty(_FeelingEvasFormComponent, "forcDisplayName", "Ressenti patient"), _defineProperty(_FeelingEvasFormComponent, "fullComponentId", "feeling-evas/form"), _defineProperty(_FeelingEvasFormComponent, "journalEventClass", FeelingEvasDeclaredJournalEvent), _FeelingEvasFormComponent), _applyDecoratedDescriptor(_class.prototype, "labels", [action], Object.getOwnPropertyDescriptor(_class.prototype, "labels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setProperty", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setProperty"), _class.prototype), _class);
export { FeelingEvasFormComponent as default };